module.exports = __webpack_public_path__ + "img/horizontal-dots-blue.596e4626.svg";